export default "__VITE_ASSET__f1be0315__"